export default __webpack_public_path__ + "static/media/2b.7c8bd088.png";